export const treeSelectStyles = {
  container: {
    position: 'relative',
    paddingBottom: '6px',
    minWidth: '350px',
    width: '100%',
    maxWidth: '400px',

    '& .label': {
      fontSize: '12px',
      fontFamily: 'Rubik, sans-serif',
      color: 'rgba(0, 0, 0, 0.54)',
      marginBottom: '6px',
      minHeight: '14px',
    },

    '&.error .label': {
      color: 'rgb(244, 67, 54)',
    },

    '&.error .rendered-value': {
      borderBottom: '2px solid rgb(244, 67, 54)',
      color: 'rgb(244, 67, 54)',
    },

    '& .rendered-value': {
      fontFamily: 'Rubik, sans-serif',
      fontSize: '14px',
      minHeight: '17px',
      minWidth: '350px',
      width: '100%',
      maxWidth: '400px',
      lineHeight: '18px',
      paddingTop: '1px',
      paddingBottom: '5px',
      borderBottom: '1px solid #c5d0de',

      '& > div:not(:last-child)': {
        marginBottom: '0.4rem',
        paddingBottom: '0.2rem',
        borderBottom: '1px solid #f0f0f0',
      },
    },
  },

  dropdownWrapper: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',

    '& .dropdown, & .dropdown-trigger': {
      outline: 'none',
      display: 'block',
      width: '100%',
      height: '100%',

      '&::after, & .tag-list': {
        display: 'none',
      },

      '& .dropdown-trigger': {
        '&.arrow': {
          border: 0,
          boxSizing: 'border-box',

          '&:before': {
            content: '""',
            width: '12px',
            height: '6px',
            position: 'absolute',
            top: '28px',
            right: 0,
            background: 'url("/img/tree-select-arrow.svg") top right no-repeat',
            transform: 'rotate(-180deg)',
            transition: '0.1s ease-out',
          },

          '&.top:before': {
            transform: 'rotate(0)',
          },
        },
      },
    },

    '& .dropdown-content': {
      position: 'absolute',
      top: '50px',
      height: '175px',
      maxHeight: '175px',
      width: '400px',
      minWidth: '350px',
      overflowY: 'auto',
      border: '1px solid #89a5ca',
      boxSizing: 'border-box',
      boxShadow: '-7px 9px 15px rgba(137, 165, 202, 0.17)',
      borderRadius: '4px',
      marginRight: '-12px',
      zIndex: 1000,

      '&::-webkit-scrollbar-track': {
        borderLeft: '1px solid #89a5ca',
      },

      '&::-webkit-scrollbar': {
        width: '12px',
      },

      '&::-webkit-scrollbar-thumb': {
        background: '#109cf1',
        borderRadius: '0 4px 4px 0',
      },

      '& .node': {
        '&[style*="20px"]': {
          marginLeft: '5px',
        },

        '&[style*="40px"]': {
          marginLeft: '10px',
        },

        '& label': {
          fontFamily: 'Rubik, sans-serif',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '14px',
          lineHeight: 'normal',
          color: '#354052',
        },

        '&.tree': {
          display: 'flex',

          '& label': {
            marginTop: '4px',
          },

          '& .toggle': {
            order: 2,
            position: 'relative',
            width: '12px',
            height: '12px',
            margin: '6px 0 0 10px',

            '&::after': {
              content: '""',
              position: 'absolute',
              width: '12px',
              height: '12px',
              background: 'url("/img/tree-select-arrow-sm.svg") center no-repeat',
              display: 'block',
              transition: '0.1s ease-out',
            },

            '&.expanded::after': {
              transform: 'rotate(180deg)',
            },
          },
        },

        '&.leaf .toggle': {
          display: 'none',
        },

        '& .checkbox-item': {
          position: 'relative',
          width: '1rem',
          height: '1rem',
          marginRight: '0.75rem',
          cursor: 'pointer',
          WebkitAppearance: 'none',
          MozAppearance: 'none',
          appearance: 'none',
          outline: 0,
          verticalAlign: 'middle',
          border: 'none',

          '&:before': {
            content: '""',
            position: 'absolute',
            left: '0px',
            top: '0px',
            zIndex: 1,
            width: '100%',
            height: '100%',
            border: '1px solid #354052',
            boxSizing: 'border-box',
            borderRadius: '4px',
          },

          '&:checked:before': {
            borderColor: '#2196f3',
            background: '#109cf1 url("/img/check-mark-white.svg") no-repeat center',
          },

          '&:checked ~ span': {
            color: '#109cf1',
          },
        },

        '&.partial .checkbox-item:before': {
          backgroundColor: '#459edd',
          borderColor: '#459edd',
          outline: '1px solid white',
          outlineOffset: '-3px',
          borderRadius: 0,
        },

        '&.disabled .checkbox-item': {
          '& ~ span': {
            color: '#ccc',
          },

          '&:before': {
            borderColor: '#bbb',
            backgroundColor: '#ccc',
          },
        },

        '& .searchLoader': {
          display: 'none',
        },
      },
    },
  },
};
